import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Button, Checkbox } from '@salesforce/design-system-react';

import EmailScreen from './steps/altText/emailScreen';
import RegisterScreen from './steps/altText/registerScreen';
import AltTextRecap from './steps/altText/recap';

import KeynoteSelectorScreen from './steps/captions/keynoteSelectorScreen';
import CaptionsRecap from './steps/captions/recap';

import LunchSelectorScreen from './steps/keyboard/lunchSelectorScreen';
import KeyboardRecap from './steps/keyboard/recap';

import SessionSelectorScreen from './steps/color/sessionSelectorScreen';
import ColorRecap from './steps/color/recap';

import Finale from './finale';

import { CONFERENCE_NAME } from './constants';

/*
 * Dummy component used to easily create screenshot image 
import DiscountCode from './steps/altText/discountCode';
 *
*/

const steps = [
  {
    title: 'Step 1',
    instructions: `You've received an email to register for ${CONFERENCE_NAME}. Use discount code on Registration form.`,
    screens: [
      { left: EmailScreen, right: null },
      { left: EmailScreen, right: RegisterScreen},
      { left: EmailScreen, right: AltTextRecap }
    ],
  },
  {
    title: 'Step 2',
    instructions: 'Preview these speakers\' unique stories below and choose a keynote to attend.',
    screens: [
      { left: KeynoteSelectorScreen, right: null },
      { left: KeynoteSelectorScreen, right: CaptionsRecap}
    ]
  },
  {
    title: 'Step 3',
    instructions: 'Sign up for two awesome workshops.',
    screens: [
      { left: SessionSelectorScreen, right: null },
      { left: SessionSelectorScreen, right: ColorRecap}
    ]
  },
  {
    title: 'Step 4',
    instructions: 'Your mouse died! Tab to the Meal dropdown and use your arrow keys to select your lunch.',
    screens: [
      { left: LunchSelectorScreen, right: null },
      { left: LunchSelectorScreen, right: KeyboardRecap}
    ]
  },

  {
    title: null,
    instructions: 'Thanks for joining us!',
    screens: [
      { left: Finale, right: null }
    ]
  }
];

let screens = [];

for (let i = 0; i < steps.length; i++) {
  screens = screens.concat(steps[i].screens.map((screen) => {
    return ({
      step: i,
      left: screen.left,
      right: screen.right
    })
  }));
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      screens: screens,
      currentScreen: screens[0],
      currentScreenIndex: 0,
      appStarted: false,

      steps: steps,
      currentStep: steps[0],
      currentStepIndex: 0,
    };
    this.settingsOpenButton = React.createRef();
    this.settingsCloseButton = React.createRef();
    this.appStarted = this.appStarted.bind(this);
    this.nextScreen = this.nextScreen.bind(this);
    this.decrementStep = this.decrementStep.bind(this);
    this.incrementStep = this.incrementStep.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showSettings !== this.state.showSettings) {
      const buttonToFocus = this.state.showSettings ? this.settingsCloseButton : this.settingsOpenButton;
      ReactDOM.findDOMNode(buttonToFocus.current).focus();
    }
  }

  getFirstScreenIndex = function(step) {
    for (var i = 0; i < this.state.screens.length; i++) {
      if (this.state.screens[i].step === step) {
        return i;
      }
    }
  }

  getLastScreenIndex = function(step) {
    for (var i = this.state.screens.length-1; i >= 0; i--) {
      if (this.state.screens[i].step === step) {
        return i;
      }
    }
  }

  setCurrentScreen(screenIndex) {
    const screen = this.state.screens[screenIndex];
    const stepIndex = screen.step;
    this.setState({
      currentScreen: screen,
      currentScreenIndex: screenIndex,
      currentStep: this.state.steps[stepIndex],
      currentStepIndex: stepIndex
    });
  }

  incrementStep = function() {
    if (this.state.currentStepIndex < this.state.steps.length) {
      const newScreenIndex = this.getFirstScreenIndex(this.state.currentStepIndex + 1);
      this.setCurrentScreen(newScreenIndex);
    }
  }

  decrementStep = function() {
    if (this.state.currentStepIndex > 0) {
      const newScreenIndex = this.getFirstScreenIndex(this.state.currentStepIndex - 1);
      this.setCurrentScreen(newScreenIndex);
    }
  }

  nextScreen = function() {
    if (this.state.currentScreenIndex < this.state.screens.length - 1) {
      this.setCurrentScreen(this.state.currentScreenIndex + 1);
    } else {
      this.reset();
    }
  }

  reset() {
    window.location.reload();
  }

  renderPreviousStepButton() {
    return (
      <div className='slds-float_left'>
        <Button
          disabled={this.state.currentStepIndex === 0 ? true : null}
          assistiveText={{ icon: 'Previous Step'}}
          iconCategory='utility'
          iconName='back'
          iconSize='large'
          inverse
          onClick={this.decrementStep}
          title='Previous Step'
          variant='icon'
        />
      </div>
    )
  }

  appStarted() {
    return this.setState({ appStarted: true });
  }

  renderNextStepButton() {
    if (this.state.steps.length > this.state.currentStepIndex + 1) {
      return (
        <div className='slds-float_right'>
          { !this.state.appStarted
            ? <Button
                className='phl pvs caps f3'
                onClick={this.appStarted}
                label='Start'
                variant='brand'
              />
            : <Button
                assistiveText={{ icon: 'Next Step'}}
                iconCategory='utility'
                iconName='forward'
                iconSize='large'
                inverse
                onClick={this.incrementStep}
                title='Next Step'
                variant='icon'
              />
          }
        </div>
      )
    } else {
      return (
        <div className='slds-float_right'>
          <Button
            onClick={this.reset}
            label='Restart'
            variant='neutral'
          />
        </div>
      );
    }
  }

  renderContinueButton() {
    if (this.state.currentScreenIndex < this.state.screens.length - 1) {
      return (
        <Button
          label='Continue'
          onClick={this.nextScreen}
          variant='brand' />
      ) 
    } else {
      return (
        <Button
          label='Reset'
          onClick={this.reset}
          variant='destructive' />
      )
    }
  }

  renderLeft(screen) {
    const Left = screen.left;
    return (
      <Left 
        appStarted={this.state.appStarted}
        accessible={this.state.accessible} 
        currentScreenIndex={this.state.currentScreenIndex} 
        nextFunc={this.nextScreen} 
        nextDisabled={this.state.currentScreen.right ? true : false}
      />
    );
  }

  renderRight(screen) {
    if (screen.right) {
      const Right = screen.right;
      return (<Right accessible={this.state.accessible} nextFunc={this.nextScreen} />);
    }
    return null;
  }

  renderSettings() {
    if (this.state.showSettings) {
      return (
        <section className='temporary-accessible-toggle bg-white bra-25'>
          <Button
            assistiveText={{ icon: 'Close Demo Settings'}}
            iconCategory='utility'
            iconName='close'
            iconSize='large'
            onClick={() => {this.setState({showSettings : false})}}
            title='Next Step'
            variant='icon'
            className='slds-float_right slds-popover__close'
            ref={this.settingsCloseButton}
          />
          <header className='slds-popover__header'>
            <h2 className='slds-text-heading_small bold'>Demo Settings</h2>
          </header>
          <div className='slds-popover__body pvm'>
            <Checkbox
              label='Accessible UI'
              id='accessibleToggle'
              variant='toggle'
              onChange={(e) => { this.setState({accessible: !this.state.accessible})}}
            />
          </div>
        </section>
      );
    } else {
      return (
        <div className='temporary-accessible-toggle'>
          <Button
            assistiveText={{ icon: 'Demo Settings'}}
            iconCategory='utility'
            iconName='settings'
            iconSize='large'
            inverse
            onClick={() => {this.setState({showSettings : true})}}
            title='Next Step'
            variant='icon'
            className='pas mas'
            ref={this.settingsOpenButton}
          />
        </div>
      );
    }
  }

  render() {
    const step = this.state.currentStep;
    const screen = this.state.currentScreen;
    const backgroundStyle = {
      backgroundImage: 'url("assets/images/sample-background.jpeg")',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      position: 'fixed',
      overflow: 'auto'
    }
    
    return (
      <div className='App' style={backgroundStyle}>
        <header className='app-header bg-darkblue text-white slds-clearfix' aria-label='Instructions'>
          <h1 className='slds-text-heading_large dib' aria-live='polite' aria-atomic='true'>
            {step.title ? step.title + ': ' : null}{step.instructions}
          </h1>
          {this.renderPreviousStepButton()}
          {this.renderNextStepButton()}
        </header>
        <div className='ptl ht-90 slds-grid'>
          <section className='ht-full screen-animation-container'>
            <div className='ht-full screen horz-center'>
              {this.renderLeft(screen)}
            </div>
          </section>
          <section className={classNames('ht-full screen-animation-container', {
              'dn': !screen.right,
              'show-right-screen': screen.right
            })}>
            <div className='ht-full screen horz-center'>
              {this.renderRight(screen)}
            </div>
          </section>
        </div>
        {this.renderSettings()}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js